export default __webpack_public_path__ + "static/media/nav-arrow-white.f0ea69a1.svg";